import { useTolgee, useTranslate } from '@tolgee/react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { capitalizeFirst } from '../../utils/capitalize';

type Props = {
  userName: string;
  fridgeName: string;
  openedAt: string;
  firstName: string;
};

const AbandonedBusinessGreeting: React.FC<Props> = ({
  userName,
  fridgeName,
  openedAt,
  firstName,
}) => {
  const { t } = useTranslate();
  const { getLanguage } = useTolgee();
  const language = getLanguage() || 'fr';

  const formattedDate = useMemo(() => {
    const date = dayjs(openedAt);

    if (!date.isValid()) return openedAt;

    return date.locale(language).format('MMMM D, YYYY h:mm A'); // similar to long date + short time
  }, [openedAt, language]);

  return (
    <div style={{ marginBottom: 28 }}>
      <Typography.Title
        level={3}
        style={{ color: '#1a3c34', marginBottom: 8, fontWeight: 700 }}
      >
        {t('Hello')} {capitalizeFirst(firstName)},
      </Typography.Title>
      <Typography.Text
        style={{
          color: '#6b7b8a',
          fontSize: 15,
          lineHeight: 1.6,
          display: 'block',
        }}
      >
        {t('You opened the fridge')}{' '}
        <strong style={{ color: '#1a3c34' }}>{fridgeName}</strong> {t('on')}{' '}
        <strong style={{ color: '#1a3c34' }}>{formattedDate}</strong>.
      </Typography.Text>
      <Typography.Text
        style={{
          color: '#6b7b8a',
          fontSize: 15,
          lineHeight: 1.6,
          display: 'block',
          marginTop: 4,
        }}
      >
        {t(
          'Select the items you took, or explain at the bottom of the page what happened so we can reactivate your account.',
        )}
      </Typography.Text>
    </div>
  );
};

export default AbandonedBusinessGreeting;
